import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const ref = sp.get("ref");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries >= 10) { setStatus("timeout"); return; }
        setTries((n) => n + 1);
        t = setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [sid]);

  return (
    <div className="min-h-screen bg-[#090D14] text-white">
      <Header />
      <div className="max-w-2xl mx-auto px-4 pt-32 pb-20 text-center">
        {status === "polling" && <><Loader2 className="w-12 h-12 mx-auto animate-spin text-amber-400" /><p className="mt-6 text-slate-300">Confirming payment…</p></>}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-500/20 grid place-items-center"><CheckCircle2 className="w-9 h-9 text-emerald-400" /></div>
            <h1 className="font-display text-4xl font-extrabold mt-6">Payment received</h1>
            <p className="mt-3 text-slate-400">Ride <span className="font-mono text-amber-400">#{ref}</span> is fully paid. See you soon.</p>
            <Link to="/"><Button className="btn-gold rounded-full mt-8 px-8 h-12">Back to home</Button></Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <h1 className="font-display text-3xl font-bold mt-6">Still processing…</h1>
            <p className="mt-3 text-slate-400">Payment may take a moment to reflect. Contact us on +64225250123 if it doesn't clear.</p>
            <Link to="/"><Button variant="outline" className="mt-8 rounded-full border-white/15 bg-transparent hover:bg-white/5 text-white">Back to home</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
